var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCaretup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0965 7.64351C10.0681 7.71203 10.02 7.7706 9.95834 7.8118C9.89667 7.85301 9.82417 7.875 9.75 7.875H2.25C2.17583 7.875 2.10333 7.85301 2.04166 7.8118C1.97999 7.77059 1.93193 7.71203 1.90354 7.6435C1.87516 7.57498 1.86774 7.49958 1.88221 7.42683C1.89668 7.35409 1.9324 7.28727 1.98484 7.23483L5.73484 3.48484C5.76966 3.45002 5.811 3.42239 5.8565 3.40355C5.90199 3.3847 5.95076 3.375 6 3.375C6.04925 3.375 6.09801 3.3847 6.14351 3.40355C6.189 3.42239 6.23034 3.45002 6.26516 3.48484L10.0152 7.23483C10.0676 7.28727 10.1033 7.35409 10.1178 7.42684C10.1323 7.49958 10.1248 7.57498 10.0965 7.64351Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCaretup);
export default __webpack_public_path__ + "static/media/select-caretup.e41c202600ed08006280f57785086cec.svg";
export { ForwardRef as ReactComponent };